import { buffers } from "redux-saga";
import { actionChannel, call, fork, put, SagaReturnType, take } from "redux-saga/effects";
import slice from "./reducer";

import notificationDealNotificationsApi from "../../api/apiServices/backOffice/controllers/dealQuestions/dealQuestions.api";
import { DealNotificationDataConverter } from "../../viewModels/Notification/DealNotificationModel";
import globalSlice from "../../containers/App/reducer";

function* loadContextWatcher() {
  const channel: import("redux-saga").Channel<ReturnType<typeof slice.actions.loadContext>> = yield actionChannel(
    slice.actions.loadContext.type,
    buffers.sliding(1),
  );
  while (true) {
    const { payload }: ReturnType<typeof slice.actions.loadContext> = yield take(channel);
    const { success, reject }: SagaReturnType<typeof notificationDealNotificationsApi.context> = yield call(
      notificationDealNotificationsApi.context,
      payload,
    );
    if (success) yield put(slice.actions.loadContextSuccess(success.payload));
    if (reject) yield put(slice.actions.loadContextReject(payload));
  }
}

function* createDealNotificationWatcher() {
  const channel: import("redux-saga").Channel<ReturnType<typeof slice.actions.createDealNotification>> = yield actionChannel(
    slice.actions.createDealNotification.type,
  );
  while (true) {
    const { payload }: ReturnType<typeof slice.actions.createDealNotification> = yield take(channel);
    const { closeNotificationId, ...dto } = payload;

    const { success, reject }: SagaReturnType<typeof notificationDealNotificationsApi.create> = yield call(
      notificationDealNotificationsApi.create,
      dto,
    );

    if (success) {
      yield put(slice.actions.createDealNotificationSuccess(DealNotificationDataConverter.convertDealNotification(success.payload)));

      if (closeNotificationId) {
        yield put(globalSlice.actions.closeDealNotification({ id: closeNotificationId, officeType: dto.officeType }));
      }
    }

    if (reject) {
      yield put(slice.actions.createDealNotificationReject(dto.requestId));
    }
  }
}

export default function* createMessageModalSaga() {
  yield fork(loadContextWatcher);
  yield fork(createDealNotificationWatcher);
}
